import React from 'react';
import styled from '@emotion/styled';

const ProgressContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const ProgressTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1.2rem;
`;

const ProgressBarWrapper = styled.div`
  width: 100%;
  background-color: #ecf0f1;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
`;

const ProgressBarFill = styled.div`
  height: 20px;
  background: linear-gradient(90deg, #3498db, #2ecc71);
  border-radius: 10px;
  transition: width 0.3s ease;
  width: ${props => props.progress}%;
`;

const ProgressText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const ProgressPercentage = styled.span`
  font-weight: 600;
  color: #2c3e50;
`;

const StatusMessage = styled.div`
  color: #7f8c8d;
  font-style: italic;
  min-height: 1.2rem;
`;

const StepList = styled.div`
  margin-top: 1rem;
`;

const StepItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  color: ${props => {
    if (props.completed) return '#27ae60';
    if (props.current) return '#3498db';
    return '#bdc3c7';
  }};
  font-weight: ${props => props.current ? '600' : '400'};
`;

const StepIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  font-size: 12px;
  font-weight: bold;
  background-color: ${props => {
    if (props.completed) return '#27ae60';
    if (props.current) return '#3498db';
    return '#ecf0f1';
  }};
  color: ${props => {
    if (props.completed || props.current) return 'white';
    return '#bdc3c7';
  }};
`;

const ProgressBar = ({ 
  progress = 0, 
  status = '', 
  steps = [], 
  currentStep = 0 
}) => {
  return (
    <ProgressContainer data-cy="main-extraction-progress">
      <ProgressTitle>Processing Documents</ProgressTitle>
      
      <ProgressText>
        <span>Progress</span>
        <ProgressPercentage>{Math.round(progress)}%</ProgressPercentage>
      </ProgressText>
      
      <ProgressBarWrapper data-cy="main-progress-bar">
        <ProgressBarFill progress={progress} data-cy="main-progress-fill" />
      </ProgressBarWrapper>
      
      <StatusMessage>
        {status || 'Preparing to process documents...'}
      </StatusMessage>
      
      {steps.length > 0 && (
        <StepList>
          {steps.map((step, index) => (
            <StepItem 
              key={index}
              completed={index < currentStep}
              current={index === currentStep - 1}
            >
              <StepIcon 
                completed={index < currentStep}
                current={index === currentStep - 1}
              >
                {index < currentStep ? '✓' : index + 1}
              </StepIcon>
              {step}
            </StepItem>
          ))}
        </StepList>
      )}
    </ProgressContainer>
  );
};

export default ProgressBar;
